import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

/**
 * Fetches a list from the CMS, returning a fallback until (or unless) it
 * arrives.
 *
 * A marketing page must never depend on the CMS being reachable: the API sits
 * on a different host, and production CORS is scoped to chickrah.com, so any
 * other origin is blocked by design. The fallback is what renders in that case.
 */
export function useCmsList(endpoint, { fallback = [], map = (x) => x } = {}) {
  const [items, setItems] = useState(fallback);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    api
      .get(endpoint)
      .then(({ data }) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data.map(map).filter(Boolean) : [];
        if (list.length) setItems(list);
      })
      .catch(() => {
        /* Keep the fallback. */
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });

    return () => {
      cancelled = true;
    };
  }, [endpoint]);

  return { items, loaded };
}
